import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AdminDashboard() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/overview").then(({ data }) => setData(data)).catch(() => {}); }, []);

  const cards = data
    ? [
        { label: "Challenge briefs", value: data.challenges, sub: `${data.challenges_new} new` },
        { label: "Network applications", value: data.applications, sub: `${data.applications_new} new` },
        { label: "Capabilities", value: data.capabilities, sub: "catalogue records" },
        { label: "Projects", value: data.projects, sub: "illustrative + live" },
      ]
    : [];

  return (
    <div>
      <h1 className="font-display text-3xl font-bold text-navy">Overview</h1>
      <p className="mt-1 text-sm text-[var(--mineral)]">Signed in as {data?.role}.</p>
      <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {cards.map((c) => (
          <div key={c.label} className="rounded-2xl border border-[var(--line)] bg-[var(--paper)] p-6" data-testid={`stat-${c.label.toLowerCase().replace(/\s+/g, "-")}`}>
            <p className="font-display text-4xl font-extrabold text-navy">{c.value}</p>
            <p className="mt-1 text-sm font-medium text-navy">{c.label}</p>
            <p className="font-mono text-xs text-[var(--cobalt)]">{c.sub}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
